import { Injectable } from '@angular/core';
import { Router, CanActivate, CanActivateChild } from '@angular/router';
import { AuthenticationService } from 'app/core/authentication/authentication.service';

@Injectable()
export class AuthGuardService implements CanActivate, CanActivateChild {

  constructor(public auth: AuthenticationService, public router: Router) {}

  private _validatesUser(): boolean {
    if (!this.auth.isUserAuthenticated()) {
      console.log('Não autenticado. Redirecionando para home.');
      this.router.navigate(['login']);
      return false;
    }
    return true;
  }

  canActivate(): boolean {
    return this._validatesUser();
  }

  canActivateChild(): boolean {
    return this._validatesUser();
  }

}
